import { render, staticRenderFns } from "./Thing.vue?vue&type=template&id=5b8bc250&scoped=true"
import script from "./Thing.vue?vue&type=script&lang=js"
export * from "./Thing.vue?vue&type=script&lang=js"
import style0 from "./Thing.vue?vue&type=style&index=0&id=5b8bc250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8bc250",
  null
  
)

export default component.exports